import { useEffect, useRef } from "react";

type Listener = () => void;

// Переподключения WebSocket подписок (graphql-ws, событие connected после
// первого). Пока сокет лежал, события подписок терялись: экраны с живым
// состоянием (диалог эфира) по этому сигналу перезапрашивают данные.
const listeners = new Set<Listener>();
let connectedOnce = false;

/** Вызывается из `on.connected` клиента graphql-ws (shared/utils/apollo.ts). */
export function notifyWsConnected(): void {
  if (!connectedOnce) {
    connectedOnce = true;
    return;
  }
  listeners.forEach((listener) => listener());
}

export function onWsReconnected(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Колбэк на каждое переподключение сокета, пока `enabled`. */
export function useWsReconnected(callback: Listener, enabled = true): void {
  const ref = useRef(callback);
  ref.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    return onWsReconnected(() => ref.current());
  }, [enabled]);
}
